import { render, staticRenderFns } from "./LeaveTransactions.vue?vue&type=template&id=4f6299ea&scoped=true&"
import script from "./LeaveTransactions.vue?vue&type=script&lang=js&"
export * from "./LeaveTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6299ea",
  null
  
)

export default component.exports